// extracted by mini-css-extract-plugin
export default {"container":"InfoInventoryForm_container__OluDW","header":"InfoInventoryForm_header__-bISx"};